import { UserRole } from '@common/enums/user-roles.enum';

export const environment = {
  production: false,
  SCARF_ANALYTICS: false,
  adminRoot: '/app',
  logOut:'/user/login',
  // socketIOPath: '/socket.io', // for Local
  socketIOPath: '/api/socket.io',  // for APP and Beta
  wooCreateOrderUrl: 'OrderStaging/orders/',
  splendidCreateOrderUrl: 'OrderStaging/splendidAccountsOrder/',
  apiUrl: 'https://app.shipkardo.pk/api/', // For APP
  // apiUrl: 'https://web.shipkardo.pk/api/', // For Web
  // apiUrl: 'https://beta.shipkardo.pk/api/', // For BETA
  //  apiUrl: 'https://localhost:1337/',  // For LOCAL
  splendidApi: "https://app.splendidaccounts.com/api", // For APP and Beta
  // splendidApi: "http://qa.splendidaccounts.com/api", // For QA-WEBSERVER
  // splendidApi: "http://localhost:44356/api", // For LOCAL
  defaultMenuType: 'menu-default',
  subHiddenBreakpoint: 1440,
  menuHiddenBreakpoint: 768,
  themeColorStorageKey: 'vien-themecolor',
  isMultiColorActive: false,
  defaultColor: 'light.blueyale',
  isDarkSwitchActive: false,
  defaultDirection: 'ltr',
  themeRadiusStorageKey: 'vien-themeradius',
  isAuthGuardActive: true,
  defaultRole: UserRole.Admin,
  productName: 'SHIPKARDO',
  fbAppId: '990754259391130',
  fbConfigId: '1047055887100022'
};
